import Keycloak from "keycloak-js";
import { KeyCloakUser } from "./models";

declare const genv: any;

export class KeycloakClient {
  private instance: Keycloak;

  constructor() {
    this.instance = new Keycloak({
      url: genv.IDP_SERVER_URL,
      realm: genv.IDP_REALM || "Garuda2x",
      clientId: genv.IDP_RESOURCE || "garuda-store",
    });
    this.instance.onTokenExpired = () => {
      this.instance
        ?.updateToken(-1)
        .then((success: boolean) => {})
        .catch((error: Error) => {});
    };
    this.instance.onAuthLogout = () => this.instance.logout();
  }

  async init() {
    try {
      const isAuthenticated = await this.instance.init({
        onLoad: "check-sso",
        responseMode: "query"
      });
      return isAuthenticated;
    } catch (error) {
      console.error("Failed to complete authentication flow:", error);
    }
  }

  login() {
    this.instance.login({});
  }

  logout() {
    this.instance.logout();
  }

  getIdToken() {
    return this.instance.idTokenParsed as KeyCloakUser;
  }

  getAccessToken() {
    return this.instance.token;
  }

  register() {
    this.instance.register();
  }
}